export default {"src":"/_next/static/media/nationwide.39221c7a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};